import {
    FETCH_DEP_PAID_BEGIN,
    FETCH_DEP_PAID_ERROR,
    FETCH_DEP_PAID_SUCCESS,

    POST_DEP_PAID_RESET,
    POST_DEP_PAID_SUCCESS,
    POST_DEP_PAID_ERROR,
    POST_DEP_PAID_BEGIN
} from '../actions/atelierExtrasActions'

const initialState = {
    depPaid: {},
    fetchDepPaid: {
        loading: false,
        error: false
    },
    postDepPaid: {
        saving: false,
        saved: false,
        error: false
    }
}

export default function atelierExtrasReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_DEP_PAID_BEGIN:
            return {
                ...state,
                fetchDepPaid: {
                    loading: true,
                    error: false
                }
            }
        case FETCH_DEP_PAID_ERROR:
            return {
                ...state,
                fetchDepPaid: {
                    loading: false,
                    error: action.payload.error
                }
            }
        case FETCH_DEP_PAID_SUCCESS:
            return {
                ...state,
                depPaid: action.payload.depPaid,
                fetchDepPaid: {
                    loading: false,
                    error: false
                }
            }
        case POST_DEP_PAID_BEGIN:
            return {
                ...state,
                postDepPaid: {
                    saving: true,
                    saved: false,
                    error: false
                }
            }
        case POST_DEP_PAID_ERROR:
            return {
                ...state,
                postDepPaid: {
                    saving: false,
                    saved: false,
                    error: action.payload.error
                }
            }
        case POST_DEP_PAID_SUCCESS:
            return {
                ...state,
                postDepPaid: {
                    saving: false,
                    saved: true,
                    error: false
                }
            }
        case POST_DEP_PAID_RESET:
            return {
                ...state,
                postDepPaid: {
                    saving: false,
                    saved: false,
                    error: false
                }
            }
        default:
            return state
    }
}